/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const warnedScopeTypes = new Set()

export const formatDynamicDiscountScopeLabel = (
  scopeType,
  {
    groupLabel,
    restaurantLabel,
    fallbackLabel = null,
  }
) => {
  if (scopeType === 'group') {
    return groupLabel
  }

  if (scopeType === 'restaurant') {
    return restaurantLabel
  }

  if (scopeType && process.env.NODE_ENV !== 'production' && !warnedScopeTypes.has(scopeType)) {
    console.warn(`Unhandled dynamic discount event scope type: ${scopeType}`)
    warnedScopeTypes.add(scopeType)
  }

  return fallbackLabel
}
